// Trailing row actions: add subtask and delete.
import { Box, IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { PlusIcon } from '@/features/tasks/components/atoms/PlusIcon';
import { translate as t } from '@/i18n/useT';

/**
 * @param {{
 *   task: Task,
 *   isSmallScreen: boolean,
 *   isExecutionView: boolean,
 *   showAddSubtaskButton: boolean,
 *   showRowDelete: boolean,
 *   onStartAddingSubtask: (id: string) => void,
 *   handleDeleteTask: (id: string) => Promise<void>,
 * }} props
 */
export function TaskItemTrailingActions({
  task,
  isSmallScreen,
  isExecutionView,
  showAddSubtaskButton,
  showRowDelete,
  onStartAddingSubtask,
  handleDeleteTask,
}) {
  return (
    <Box className="task-item__trailing-actions">
      {!isSmallScreen && !isExecutionView && showAddSubtaskButton ? (
        <Box
          component="button"
          type="button"
          className="task-item__add-subtask"
          aria-label={t('taskitem.addSubtask', 'Add subtask')}
          data-testid="add-subtask-button"
          tabIndex={-1}
          onClick={(e) => {
            e.stopPropagation();
            onStartAddingSubtask(task.id);
          }}
        >
          <PlusIcon />
        </Box>
      ) : null}
      {showRowDelete ? (
        <IconButton
          size="small"
          className="task-item__delete"
          aria-label={t('taskitem.deleteTask', 'Delete task')}
          data-testid="delete-task-button"
          onClick={(e) => {
            e.stopPropagation();
            handleDeleteTask(task.id);
          }}
          sx={{ p: 0.25 }}
        >
          <DeleteOutlineIcon sx={{ fontSize: 14 }} />
        </IconButton>
      ) : null}
    </Box>
  );
}
